import {api} from '@/libs/baseApi.client';

/** Row in the share modal leaderboard snippet (built from API `placeNumber`). */
export interface LeaderboardSharePreviewRow {
  rank: number;
  displayName: string;
  /** Omitted when API does not provide a score for this row. */
  score?: number;
  isCurrentUser?: boolean;
}

export interface LeaderboardShareContent {
  placeNumber: number;
  referralLink: string;
  shareText: string;
}

/**
 * Response from POST /competitions/share-position (Share leaderboard position).
 */
export interface LeaderboardShareApiResponse {
  reward: {
    poe: number;
    coins: number;
  };
  shareContent: LeaderboardShareContent;
}

/**
 * Share current competition position. No body or query params.
 * Backend picks the active competition; once per competition.
 */
export const shareLeaderboard = async (): Promise<LeaderboardShareApiResponse> => {
  const response = await api.post<LeaderboardShareApiResponse>('/competitions/share-position');
  return response.data;
};
